<template>
  <div>
    <div class="nav" id="nav">
      <!-- <div class="logo size0">
        <img src="../assets/images/logo.png" alt="" class="middle" />
      </div> -->
      <ul>
        <li
          class=""
          v-for="(value, index) in NavInfo"
          :class="{ active: $store.state.navIndex[0] == index }"
          :key="index"
        >
          <div
            class="flex"
            :class="{ active: $store.state.navIndex[0] == index }"
            @click="setNavIndex(index, value)"
          >
            <div class="flex">
              <img :src="value.icon" alt="" class="tab-icon" />
              <span>{{ value.title }}</span>
            </div>
            <div v-if="value.child" class="triangle middle"></div>
          </div>
          <div
            class="list"
            :class="{ active: $store.state.navIndex[0] == index }"
          >
            <div
              class="item"
              :class="{ on: $store.state.navIndex[1] === i }"
              v-for="(v, i) in value.child"
              :key="i"
              @click="url(v, i)"
            >
              <span>{{ v.name }}</span>
            </div>
          </div>
        </li>
      </ul>

      <div
        class="switchSchool"
        @click="openSelectSchool"
        v-if="!$store.state.userinfo.isSuper"
      >
        <span>{{ selectedSchoolName ? selectedSchoolName : "暂无学校" }}</span>
        <img src="@/assets/images/switchLogo.png" alt="" />
      </div>
    </div>

    <el-dialog
      title="学校"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="dialog-main">
        <div
          class="dialog-item"
          :class="{ active: selectedSchool == v.schoolId }"
          v-for="(v, i) in schoolList"
          :key="i"
          @click="selectSchool(v)"
        >
          <div class="school-info">
            <img src="@/assets/images/schoolIcon.png" alt="" />
            <span>{{ v.schoolName }}</span>
          </div>
          <el-radio v-model="selectedSchool" :label="v.schoolId">{{
            ""
          }}</el-radio>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="selectSchoolHandle">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetPowerApi,
  GetAttestationSchoolListApi,
  SelectSchoolApi
} from "@/request/requestApi";
export default {
  props: ["user"],
  data() {
    return {
      schoolList: [],
      selectedSchool: "",
      selectedSchoolName: "",
      dialogVisible: false,
      NavInfo: "",
      studentNav: [
        {
          icon: require("../assets/images/首页.png"),
          title: "首页",
          path: "/main/index"
        },
        {
          icon: require("../assets/images/用户管理.png"),
          title: "用户管理",
          child: [
            {
              name: "学校管理",
              path: "/userManagement/shool"
            },
            {
              name: "用户管理",
              path: "/userManagement/user"
            },
            {
              name: "管理员管理",
              path: "/userManagement/admin"
            },
            {
              name: "企业管理",
              path: "/userManagement/enterprise"
            }
          ]
        },
        {
          icon: require("../assets/images/内容管理.png"),
          title: "内容管理",
          child: [
            {
              name: "数据统计",
              path: "/contentManagement/dataStatistics"
            },
            {
              name: "全部内容",
              path: "/contentManagement/allContent"
            },
            {
              name: "内容过滤",
              path: "/contentManagement/contentFiltering"
            }
          ]
        },
        {
          icon: require("../assets/images/wishIcon.png"),
          title: "行业领域",
          path: "/main/industryField"
        },
        {
          icon: require("../assets/images/认证审核.png"),
          title: "认证审核",
          child: [
            {
              name: "学生认证",
              path: "/authentication/student"
            },
            {
              name: "教职工认证",
              path: "/authentication/teacher"
            },
            {
              name: "管理员认证",
              path: "/authentication/admin"
            },
            {
              name: "企业认证",
              path: "/authentication/enterprise"
            }
          ]
        },
        {
          icon: require("../assets/images/返校预约.png"),
          title: "返校预约",
          child: [
            {
              name: "预约管理",
              path: "/backSchool/appointment"
            },
            {
              name: "返校统计",
              path: "/backSchool/backStatistic"
            }
          ]
        },
        {
          icon: require("../assets/images/wishIcon.png"),
          title: "心愿管理",
          path: "/main/wishManage"
        },
        {
          icon: require("../assets/images/意见反馈.png"),
          title: "意见反馈",
          path: "/main/feedback"
        }
      ]
    };
  },
  mounted() {},
  created() {
    // this.NavInfo = this.studentNav;
    this.getUserPower();

    this.getSchoolList();
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    async openSelectSchool() {
      if (
        (!this.selectedSchoolName || !this.selectedSchool) &&
        !this.schoolList.length
      )
        return;
      await this.getSchoolList();
      this.dialogVisible = true;
    },
    selectSchool(val, idx) {
      this.selectedSchool = val.schoolId;
    },
    async getSchoolList() {
      let res = await GetAttestationSchoolListApi();
      if (res.succeed) {
        this.schoolList = res.data;

        this.selectedSchool = this.schoolList.find(item => item.isSelected)
          ? this.schoolList.find(item => item.isSelected).schoolId
          : "";
        this.selectedSchoolName = this.schoolList.find(item => item.isSelected)
          ? this.schoolList.find(item => item.isSelected).schoolName
          : "";
      }
    },
    async selectSchoolHandle() {
      this.$confirm("确认切换学校吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await SelectSchoolApi({ schoolId: this.selectedSchool });
          if (res.succeed) {
            this.$store.commit("setToken", res.data.token);
            that.$store.commit("setUserinfo", JSON.stringify({...res.data.user,adminType:res.data.glyType}));
            this.$store.commit("setNavIndex", [0, 0]);
            localStorage.setItem("token", res.data.token);
            this.dialogVisible = false;
            this.$message.success("切换成功");
            await this.getSchoolList();
            this.$router.push({ path: "/main/index" });
            // this.$router.go(0)
          }
        })
        .catch(() => {});
    },
    async getUserPower() {
      let res = await GetPowerApi();
      if (res.succeed) {
        this.NavInfo = this.studentNav
          .map(navItem => {
            // 查找对应的 data 项
            const matchedData = res.data.find(
              item => item.name === navItem.title && item.isNotSelected === true
            );

            if (matchedData) {
              // 如果找到了匹配的父级项
              console.log(`Matched Parent: ${navItem.title}`); // 调试信息

              if (navItem.child) {
                // 过滤出子项
                const matchedChildNames = navItem.child.filter(
                  child =>
                    matchedData.children &&
                    matchedData.children.some(
                      dataChild =>
                        dataChild.name === child.name &&
                        dataChild.isNotSelected === true
                    )
                );

                // 返回包含匹配子项的新对象
                return {
                  ...navItem, // 保留原有的 navItem 属性
                  child: matchedChildNames // 替换为匹配的子项
                };
              }

              // 如果没有子项，返回父级项
              return {
                ...navItem // 保留原有的 navItem 属性
              };
            }

            return null; // 不需要的项返回 null
          })
          .filter(item => item !== null); // 过滤掉 null 项
        //保存到store进行状态管理
        const titles = this.extractTitlesAndNames(this.NavInfo);
        this.$store.commit("setUserPermissions", titles);
      }
    },
    // 函数：提取所有的 title 和 child 中的 name
    extractTitlesAndNames(menuItems) {
      let titles = [];

      menuItems.forEach(item => {
        // 添加 title
        if (item.title) {
          titles.push(item.title);
        }

        // 如果有 child，递归提取 name
        if (item.child && Array.isArray(item.child)) {
          item.child.forEach(childItem => {
            if (childItem.name) {
              titles.push(childItem.name);
            }
          });
        }
      });

      return titles;
    },
    setNavIndex(index, value) {
      if (this.$store.state.navIndex[0] != index) {
        this.$store.commit("setNavIndex", [index, ""]);
      } else {
        this.$store.commit("setNavIndex", [-1, ""]);
      }
      if (value.path) {
        this.$router.push({ path: value.path });
      }
    },
    url(data, index) {
      if (data.data) {
        this.$router.push({ path: data.path, query: data.data });
      } else {
        this.$router.push({ path: data.path });
      }
      this.$store.commit("setNavIndex", [this.$store.state.navIndex[0], index]);
    }
  }
};
</script>
<style lang="less" scoped>
.logo {
  height: 1rem;
  width: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;
  img {
    width: 0.89rem;
    height: 0.66rem;
    // left: -200px;
    // filter: drop-shadow(200px 0 0 #af2023);
  }
}
.nav {
  position: relative;
  overflow: hidden;
  min-width: 200px;
  width: 200px;
  height: 100%;
  background: #5f79f9;
  border-right: 1px solid #eaedf0;
  box-sizing: border-box;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
}
.nav ul {
  margin-top: 0.55rem;
}
.nav li {
  cursor: pointer;
  margin: 0.1rem auto;
  width: 85%;
  border-radius: 0.06rem;
}
.nav li.active {
  // background: #72bbff;
}
.nav li > div {
  height: 0.48rem;
  line-height: 0.48rem;
  box-sizing: border-box;
  // justify-content: center;
  position: relative;
}
.nav li > div > div.flex {
  padding: 0 0.2rem;
}
.nav li > div > div.flex span {
  text-align: center;
}
.nav li > div.flex.active {
  // background-color: rgb(255,255,255);
  // box-shadow: 0px 0.03rem 0.14rem rgba(38,114,184,0.4);
  border-radius: 0.06rem;
}
.nav li > div.active span {
  // color: rgb(46,155,255);
}
.nav li .list.active {
  margin-top: 0.1rem;
  background: transparent;
}

.nav li .list .item.on {
  // background: #9dd0ff;
  background: #ffffff20;
}
.nav li .list .item.on span {
  color: #f2f9ff;
}
.nav li .img {
  width: 21px;
  height: 20px;
  margin-right: 17px;
  img {
    width: 100%;
  }
}

.nav li span {
  // width: 0.71rem;
  height: 0.4rem;
  font-size: 0.18rem;
  color: #edf5fe;
  white-space: nowrap;
}

.nav .active .triangle {
  transform: translateY(-50%) rotate(45deg);
}
.nav .active .img img {
  filter: brightness(0.5);
}

.tab-icon {
  width: 15px;
  margin-right: 16px;
  object-fit: contain;
}

.nav li .triangle {
  transition: all 0.2s;
  transform: translateY(-50%) rotate(-45deg);
  width: 0.1rem;
  height: 0.1rem;
  border: 0.02rem solid #f6fbff;
  border-left-color: transparent;
  border-top-color: transparent;
  position: absolute;
  right: 0.3rem;
}
.nav li .active .triangle {
  // border-color:  rgb(46,155,255);
  border-left-color: transparent;
  border-top-color: transparent;
}
.nav li .list {
  font-size: 0;
}

.nav .active .item {
  height: 0.44rem !important;
}

.nav li .list .item {
  overflow: hidden;
  transition: all 0.6s;
  width: 100%;
  height: 0px;
  line-height: 0.44rem;
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: center;
  border-radius: 0.06rem;
}

.nav li .list .item span {
  font-size: 0.14rem;
  color: #ffffff;
}

.nav li .list {
  height: auto;
}

.switchSchool {
  position: absolute;
  bottom: 0.36rem;
  left: 50%;
  transform: translate(-50%, 0);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    white-space: nowrap;
    font-size: 0.14rem;
    color: #ffffff;
  }
  img {
    margin-left: 0.12rem;
    width: 0.16rem;
    object-fit: contain;
  }
}
.dialog-main {
  width: 100%;
  display: flex;
  flex-direction: column;
  .dialog-item {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.2rem 0.3rem;
    border-radius: 10px;
    border: 1px solid #cccccc;
    span {
      margin-left: 0.2rem;
      font-weight: 400;
      font-size: 0.14rem;
      color: #333333;
    }
  }
  .active {
    border: 1px solid #5f79f9;
  }
  .dialog-item:nth-child(n + 2) {
    margin-top: 0.14rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/IsNav.vue